import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="phone-input"
export default class extends Controller {
  static targets = ["input"]

  connect() {
    // Add CSS
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/intl-tel-input@25.2.0/build/css/intlTelInput.css';
    document.head.appendChild(link);

    // Load intl-tel-input
    const script = document.createElement('script');
    script.src = "https://cdn.jsdelivr.net/npm/intl-tel-input@25.2.0/build/js/intlTelInput.min.js";
    script.onload = () => {
      this.initializePhoneInput();
    };
    document.head.appendChild(script);
  }

  initializePhoneInput() {
    this.iti = window.intlTelInput(this.inputTarget, {
      initialCountry: "fr",
      countryOrder: ["fr", "de", "es", "nl", "it"],
      onlyCountries: ["al", "ad", "at", "by", "be", "ba", "bg", "hr", "cz", "dk",
        "ee", "fo", "fi", "fr", "de", "gi", "gr", "va", "hu", "is", "ie", "it", "lv",
        "li", "lt", "lu", "mk", "mt", "md", "mc", "me", "nl", "no", "pl", "pt", "ro",
        "ru", "sm", "rs", "sk", "si", "es", "se", "ch", "ua", "gb"],
      loadUtils: () => import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.2.0/build/js/utils.js"),
      formatOnDisplay: true,
      nationalMode: true,
      separateDialCode: true,
      strictMode: true,
      customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
        return selectedCountryPlaceholder;
      }
    });

    // Style fixes for dark mode and Tailwind
    const style = document.createElement('style');
    style.textContent = `
      .iti { width: 100%; }
      .iti__country-list {
        background-color: var(--background);
        border-color: var(--border);
        border-radius: 0.5rem;
      }
      .iti__country:hover {
        background-color: var(--accent);
      }
      .dark .iti__country-list {
        background-color: var(--background);
        border-color: var(--border);
      }
      .iti__flag-container:hover .iti__selected-flag {
        background-color: var(--accent);
      }
    `;
    document.head.appendChild(style);

    // Add form submit handler
    this.inputTarget.closest('form').addEventListener("submit", (event) => {
      if (!this.iti.isValidNumber()) {
        event.preventDefault();
        this.inputTarget.classList.add('error');
      } else {
        this.inputTarget.value = this.iti.getNumber();
      }
    });
  }

  disconnect() {
    if (this.iti) {
      this.iti.destroy();
    }
  }
}
